import { Helmet } from 'react-helmet-async';

const seoData = {
  home: {
    title: 'Vulcan Recruitment | Construction & Engineering Recruitment Australia',
    description: 'Vulcan Recruitment is a specialist recruitment agency supporting construction, engineering, trades and industrial hiring across Melbourne, Victoria and Australia. Fast shortlists, quality candidates.',
    keywords: 'construction recruitment Melbourne, engineering recruitment Australia, trades recruitment Victoria, industrial recruitment, recruitment agency Melbourne'
  },
  about: {
    title: 'About Us | Vulcan Recruitment - Construction Recruitment Specialists',
    description: 'Learn about Vulcan Recruitment - specialist recruitment agency for construction, engineering, trades and industrial sectors. Based in Melbourne, serving all of Australia.',
    keywords: 'about vulcan recruitment, construction recruitment agency, engineering recruiters Melbourne, industrial staffing Victoria'
  },
  employers: {
    title: 'For Employers | Hire Construction & Engineering Staff | Vulcan Recruitment',
    description: 'Find skilled construction, engineering and trades staff fast. Vulcan Recruitment delivers quality candidates with thorough screening. Request staff today.',
    keywords: 'hire construction workers, engineering recruitment services, trades staffing agency, industrial workforce solutions, construction hiring Melbourne'
  },
  candidates: {
    title: 'Jobs for Candidates | Construction & Engineering Careers | Vulcan Recruitment',
    description: 'Looking for construction, engineering or trades jobs in Australia? Register with Vulcan Recruitment to access top opportunities across Melbourne and beyond.',
    keywords: 'construction jobs Melbourne, engineering careers Australia, trades jobs Victoria, industrial jobs, job seekers construction'
  },
  sectors: {
    title: 'Industry Sectors | Construction, Engineering, Trades Recruitment | Vulcan',
    description: 'Vulcan Recruitment specialises in construction, engineering, trades, industrial, infrastructure and mining support recruitment across Australia.',
    keywords: 'construction sector recruitment, engineering industry jobs, trades recruitment, industrial staffing, infrastructure recruitment, mining jobs'
  },
  contact: {
    title: 'Contact Us | Vulcan Recruitment | Construction Recruiters Melbourne',
    description: 'Contact Vulcan Recruitment for construction, engineering and trades recruitment. Located in Thomastown, Victoria. Call +61 469 362 319 or email info@vulcanrecruitment.com',
    keywords: 'contact vulcan recruitment, construction recruiters Thomastown, recruitment agency contact Melbourne'
  },
  jobs: {
    title: 'Current Job Vacancies | Construction & Engineering Jobs | Vulcan Recruitment',
    description: 'Browse current construction, engineering, trades and industrial job opportunities across Australia. Apply now through Vulcan Recruitment.',
    keywords: 'construction jobs, engineering vacancies, trades positions, industrial jobs Australia, current job openings Melbourne'
  },
  privacy: {
    title: 'Privacy Policy | Vulcan Recruitment',
    description: 'Read Vulcan Recruitment privacy policy. Learn how we collect, use and protect your personal information.',
    keywords: 'privacy policy, data protection, vulcan recruitment privacy'
  },
  terms: {
    title: 'Terms of Service | Vulcan Recruitment',
    description: 'Read Vulcan Recruitment terms of service. Understand our service agreement for employers and candidates.',
    keywords: 'terms of service, service agreement, vulcan recruitment terms'
  }
};

export function SEO({ page }) {
  const data = seoData[page] || seoData.home;
  
  return (
    <Helmet>
      <title>{data.title}</title>
      <meta name="description" content={data.description} />
      <meta name="keywords" content={data.keywords} />
      <meta property="og:title" content={data.title} />
      <meta property="og:description" content={data.description} />
      <meta name="twitter:title" content={data.title} />
      <meta name="twitter:description" content={data.description} />
    </Helmet>
  );
}

export default SEO;
